import { useEffect, useRef, useState } from "react";
import {
  getProcurements,
  createProcurement,
  deleteProcurement,
} from "../api/procurementApi";

export default function ProcurementPage() {
  const [items, setItems] = useState<any[]>([]);
  const [name, setName] = useState("");
  const abortRef = useRef<AbortController | null>(null);

  const load = async () => {
    abortRef.current?.abort();
    const controller = new AbortController();
    abortRef.current = controller;

    try {
      const res = await getProcurements({ signal: controller.signal });
      setItems(res.data ?? []);
    } catch (e: any) {
      if (e?.code === "ERR_CANCELED" || e?.name === "AbortError") return;
      console.error("Failed to load procurements:", e);
    }
  };

  useEffect(() => {
    load();
    return () => abortRef.current?.abort();
  }, []);

  const save = async () => {
    if (!name.trim()) return;
    await createProcurement({ name });
    setName("");
    load();
  };

  const remove = async (id: string) => {
    await deleteProcurement(id);
    load();
  };

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Procurement Records</h2>
      <div className="p-6">
        <h2 className="font-semibold text-xl mb-3">Procurement Management</h2>

        <button className="mb-4 px-3 py-2 bg-blue-600 text-white rounded">
          New Purchase Request
        </button>

        <div className="border rounded p-4 bg-white shadow">
          <p>Procurement Table / Create Form UI goes here</p>
        </div>
      </div>
      <div className="flex gap-2 mb-4">
        <input
          className="border px-2 py-1"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Item Name"
        />
        <button onClick={save} className="px-3 py-1 bg-blue-600 text-white">
          Add
        </button>
      </div>

      <ul className="space-y-2">
        {items.map((i) => (
          <li
            key={i.id}
            className="flex justify-between p-2 bg-white border rounded"
          >
            {i.name}
            <button
              onClick={() => remove(i.id)}
              className="text-red-600 font-semibold"
            >
              Delete
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
